// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__U4xhv","item":"Breadcrumbs_item__3ihPB","separator":"Breadcrumbs_separator__6LJ3T"};